import { env } from '@/env'

const isDev = env.NODE_ENV === 'development'

import type { ComponentType } from 'react'

import { UserIcon } from '@hugeicons/react'
import { createModuleIcon } from '@/shared/ui/ModuleIcon'

export type ModuleNavGroup = 'principal' | 'suporte'

export interface ModuleNavItem {
  slug: string
  icon: ComponentType<any>
  name: string
  href: string
  hideOnSidebar?: boolean
  navGroup?: ModuleNavGroup
}

export const modules: ModuleNavItem[] = [
  {
    slug: 'my-profile',
    icon: UserIcon,
    name: 'Minha conta',
    href: '/minha-conta',
    hideOnSidebar: true
  },
  {
    slug: 'wallet',
    icon: createModuleIcon('backpack'),
    name: 'Extrato de Recompensas',
    href: '/extrato-de-recompensas',
    hideOnSidebar: true
  },
  {
    slug: 'insights',
    icon: createModuleIcon('home'),
    name: 'Início',
    href: '/'
  },
  {
    slug: 'journeys',
    icon: createModuleIcon('journeys'),
    name: 'Jornadas',
    href: '/jornadas'
  },
  {
    slug: 'missions',
    icon: createModuleIcon('missions'),
    name: 'Missões',
    href: '/missoes'
  },
  {
    slug: 'quizzes',
    icon: createModuleIcon('quizzes'),
    name: 'Quizzes',
    href: '/quizzes'
  },
  {
    slug: 'prizes',
    icon: createModuleIcon('prizes'),
    name: 'Concursos',
    href: '/sorteios'
  },
  {
    slug: 'rewards',
    icon: createModuleIcon('shop'),
    name: 'Lojinha',
    href: '/lojinha'
  },
  { slug: 'social-feed', icon: createModuleIcon('social'), name: 'Feed Social', href: '/feed' },
  {
    slug: 'schedule',
    icon: createModuleIcon('schedule'),
    name: 'Programação',
    href: '/programacao'
  },
  {
    slug: 'partners',
    icon: createModuleIcon('partners'),
    name: 'Parceiros',
    href: '/parceiros'
  },
  {
    slug: 'library',
    icon: createModuleIcon('library'),
    name: 'Biblioteca',
    href: '/biblioteca'
  },
  // {
  //   slug: 'transmissions',
  //   icon: 'signal-stream',
  //   name: 'Transmissões',
  //   href: '/transmissoes'
  // },
  {
    slug: 'faq',
    icon: createModuleIcon('support'),
    name: 'Central de Ajuda',
    href: '/duvidas-frequentes',
    navGroup: 'suporte'
  }
]

export const sidebarNavItems: ModuleNavItem[] = modules.filter(
  module => !module?.hideOnSidebar
)
